import React, { Component } from "react";

import CroppingScreen from "Containers/CroppingScreen";
import EditProjectContainer from "Containers/EditProjectContainer";
import { PrivateRoute } from "./PrivateRoute";
// import ProfileScreen from "Containers/ProfileScreen";
import SettingsScreen from "Containers/SettingsScreen";
import navRoutes from "Navigation/NavRoutes";

import MyProjectsContainer from "Containers/MyProjectsContainer";

export default class RestrictedRoute extends Component {
  render() {
    const {
      isAuthenticated
    } = this.props;
    return (
      <>
        <PrivateRoute
          path={`${navRoutes.editProject}/:id`}
          component={EditProjectContainer}
          isAuthenticated={isAuthenticated}
        />
        <PrivateRoute
          path={`${navRoutes.editProject}/${navRoutes.editProjectDetails}/:id`}
          component={EditProjectContainer}
          isAuthenticated={isAuthenticated}
        />
        <PrivateRoute
          path={"/Settings"}
          component={SettingsScreen}
          isAuthenticated={isAuthenticated}
        />
        <PrivateRoute
          path={navRoutes.cropImage}
          component={CroppingScreen}
          isAuthenticated={isAuthenticated}
        />
        <PrivateRoute
          path={navRoutes.myProjects}
          component={MyProjectsContainer}
          isAuthenticated={isAuthenticated}
        />
      </>
    );
  }
}
